import { SUB_JOB_RETURN_REQUEST, CREATE_SUB_JOB_RETURN, GET_SUB_JOB_RETURNS, UPDATE_SUB_JOB_RETURN, DELETE_SUB_JOB_RETURN,
    SUB_JOB_RETURN_REQUEST_FAILURE } from '../types';

const initialState = {
  subJobReturns: [],
  loading: false,
  error: null,
};

const subJobReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUB_JOB_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_SUB_JOB_RETURNS: {
      return {
        ...state,
        subJobReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_SUB_JOB_RETURN:
      return {
        ...state,
        subJobReturns: [action.payload, ...state.subJobReturns],
        loading: false,
        error: null
      };
    case UPDATE_SUB_JOB_RETURN:
      const subJobReturnsData = state.subJobReturns.slice(0);
      const uIndex = subJobReturnsData.findIndex((data) => data.id === action.payload.id);
      subJobReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        subJobReturns: [ ...subJobReturnsData ],
        loading: false,
        error: null
      };
    case DELETE_SUB_JOB_RETURN:
      const subJobReturns = state.subJobReturns?.slice(0);
      const index = subJobReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        subJobReturns.splice(index, 1);
      }
      return {
        ...state,
        subJobReturns: [...subJobReturns],
        loading: false,
        error: null
      }
    case SUB_JOB_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default subJobReturnReducer;
